'use strict';

class IEquatable {
	equals(other) {
		return false;
	}
}

module.exports = IEquatable;